<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">个性化定制救援服务</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:49px;">个性化定制救援服务</h3>
      <p class="experience-para"
         style="margin-bottom:40px;">
        随着医学救援服务的全球化发展，我们的需求已不局限在随着经验增长而不断提高的医学救援能力。医学救援不应该是服务于少数人 群的一家独秀，而应该与国民保险一样切实地成为挽救更多人生命安全的服务手段。北京威马捷早在十年前开始开发信息网络管理与 数据输出及应用系统，先后实现了全球医疗机构网络信息和供应商网络信息的导入与应用，并抽取本公司的重症案件救援服务数据做 成了医疗转运信息管理和定制救援服务的基础平台AMS(Assistance Mapping System)。这一信息管理系统的应用，不只是实现了EAJ全球救援中心的信息共享，还 为我们提供了风险预判的经验及医学救援方法的演习实例。根据这一信息系统的功能特性，我们将依托于大数据背景下的医学救援服 务分为两大类，即案件发生前的医疗信息咨询服务，和案件发生后的紧急救援服务。
      </p>
      <div class="pic-box">
        <img class="img-item"
             :src="picList1"
             alt="">
        <img class="img-item"
             :src="picList2"
             alt="">
        <img class="img-item"
             :src="picList3"
             alt="">
        <img class="img-item"
             :src="picList4"
             alt="">
      </div>
      <h4 class="rescue-title"
          style="margin-bottom:25px;">全方位的紧急救援方案×专业的项目管理体系</h4>
      <p class="experience-para"
         style="margin-bottom:43px;">
        <img :src="personal8"
             alt=""
             style="width: 880px;display:block;margin:auto;">
      </p>
      <!-- <img :src="personal8"
           alt=""
           style="width: 100%"> -->
      <!-- <p class="experience-para">由专业医护人员为在海外驻地及工厂工作的会员提供健康管理咨询、紧急救援及安全指导等服务。具体包括，工作环境及现地医疗状况的调查并提供信息，意外伤害或疾病发生时的紧急救助，以及心肺复苏等急救知识的实操讲解和精神压力咨询等个人健康教育管理的服务。</p> -->
      <h4 class="rescue-title">医疗管理咨询服务</h4>
      <p class="experience-para"
         style="margin-bottom:40px;">
        [预估风险对策]是指，通过对当地医疗环境，医疗机构信息及转运路线的调查报告，事先认知潜在危险，并通过危机管理防患于未然。<br>
        在这个全球危机多样化，复杂化，深入化的时代，这种健全的预警制事前医疗信息管理咨询有着非常重要的意义。
      </p>

      <h4 class="more-case">服务内容</h4>
      <div class="personalized-list">
        <div class="personal-cell"
             v-for="(person,index) in personal"
             :key="index">
          <h5>{{person.title}}</h5>
          <p>{{person.info}}</p>
        </div>
      </div>
      <h4 class="rescue-title">个性化定制救援服务</h4>
      <p class="experience-para"
         style="margin-bottom:38px;">
        【紧急事态对策】是指，在实际发生紧急事件时将损害最小化的科学管理方法。<br/> 这种科学管理方法的关键点在于，在事件发生后如何迅速地整合相关资源以便提供最恰当的服务。

      </p>
      <h4 class="more-case">服务内容</h4>
      <div class="personalized-list">
        <div class="personal-cell"
             v-for="(service,index) in services"
             :key="index">
          <h5>{{service.title}}</h5>
          <p>{{service.info}}</p>
        </div>
      </div>
      <h4 class="rescue-title">偏远地区医疗健康管理服务</h4>
      <p class="experience-para"
         style="margin-bottom:43px;">
        <img :src="personal2"
             alt=""
             style="width: 824px;display:block;margin:0 20px;">
      </p>
      <h4 class="more-case">医疗咨询服务案例</h4>
      <p class="experience-para"
         style="margin-bottom:40px;">
        整合型医学救援服务以紧急应对预案为基础，结合专业的医疗救援客服团队，为大客户提供安心、安全的救援服务。
        <br/> ・根据不同城市的具体情况选择可接收重症患者的医院，并制定病床到病床的具体转运方案（包括转运距离，路线和机场信息，转 运方式和机型，医疗团队组成以及费用预算）。
        <br/> ・转运方式包括医疗包机、民航客机、医疗直升机、高铁、救护车，快艇等各种交通手段。
        <br/> ・在实际转运案件操作时，威马捷会本着高效救援、安全、合理控制费用的原则，根据客户需求进行线路调整。

      </p>
      <div class="pic-ls">
        <img :src="personal3"
             alt=""
             style="width: 100%;">
      </div>
    </div>
  </div>
</template>
<script>
import personal3 from '@/assets/images/rescue/personal3.jpg'
import personal2 from '@/assets/images/rescue/personal2.png'
import personal8 from '@/assets/images/rescue/personal8.jpg'
import picList1 from '@/assets/images/rescue/pic-list1.jpg'
import picList2 from '@/assets/images/rescue/pic-list2.jpg'
import picList3 from '@/assets/images/rescue/pic-list3.jpg'
import picList4 from '@/assets/images/rescue/pic-list4.jpg'
export default {
  data () {
    return {
      personal3,
      personal2,
      personal8,
      picList1,
      picList2,
      picList3,
      picList4,
      personal: [
        { title: '调查各种信息', info: '调查当地医疗体制，医院信息，体检及 预防接种相关信息，紧急救护相关信息 并整理制作资料。定期发布境外医疗及 安全相关信息。' },
        { title: '构筑偏远地区的医疗体制', info: '提供现场急救、紧急转移及就医的最佳路线与方案。' },
        { title: '制作紧急转运方案', info: '制作并提供会员在发生急重症案件时就医及海外紧急转运/归国医疗转运的方案。' },
        { title: '派遣现场救援队', info: '派遣医护人员到奥运会、马拉松、体育赛事、音乐会等大型活动现场，提供紧急救援保障。' },
        { title: '驻地医疗陪同', info: '派遣医护人员到驻地，提供身体检查、健康咨询，并对会员的健康管理提供建议。' },
        { title: '医药用品及设备的管理', info: '常备药品及基础医疗设备管理，当地特殊用药及设备的配备及管理。' },
        { title: '科学的病例管理', info: '通过对客户病例的科学管理，长期观察当地工作人员的健康情况，及时发现问题提供指导意见。' },
        { title: '精神健康管理', info: '提供精神压力咨询及评估管理。' },
        { title: '应急培训', info: '通过讲习会为会员普及应急处理相关知识，CPR/AED等急救实操培训。' },
      ],
      services: [
        { title: '安排就医', info: '为会员介绍并安排最适合的医疗机构就诊。' },
        { title: '翻译服务', info: '通过电话翻译以及派遣现场翻译人员，为会员提供医疗翻译服务，协助与现地医护人员的沟通。' },
        { title: '治疗费的挂账及代垫服务', info: '为客户提供治疗费的挂账，减额交涉，以及代理支付服务。并根据需求为会员提供合理利用保险的建议。' },
        { title: '治疗跟踪服务', info: '客户住院期间由威马捷顾问医生定期与当地主治医生取得联系，实时把握治疗情况。' },
        { title: '当地治疗评价及建议', info: '由威马捷顾问医生就当地治疗情况作出医疗专业解析，并给出建议。' },
        { title: '医疗人员的派遣', info: '根据需求，派遣相应的医疗人员赶赴当地。' },
        { title: '紧急医疗转运', info: '如果当地医疗环境无法为客户提供所需的治疗，威马捷将提供紧急转运服务，根据情况安排患者在医护人员陪同下转运回国，继续治疗。' },
        { title: '安排转运接收医院', info: '安排转动目的地的接收医院，尤其对于转运后需要持续治疗的客户，确保病床对病床的安全对接。' },
        { title: '遗体处理及转运', info: '不幸身故时，协助客户进行遗体处理。安排当地埋葬、火葬或遗体转运回国等相关事宜。' },
        { title: '保险理赔手续', info: '如果客户持有相关保险产品，威马捷可代理客户完成保险理赔手续' },
      ]
    }
  }
}
</script>
<style lang="less" scoped>
img {
  backface-visibility:hidden;
  -webkit-backface-visibility:hidden;
}
.pic-ls {
  width: 892px;
  height: 513px;
  background-color: #e9ebf4;
  margin: 0 auto 100px auto;
}
.pic-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 928px;
  margin: 0 auto 102px auto;
  .img-item {
    width: 224px;
    height: 150px;
  }
}
.more-case {
  margin-bottom: 37px;
}
.person-service {
  width: 906px;
  margin: 0 auto;
  p {
    font-size: 24px;
    color: #333130;
    line-height: 30px;
    margin: 40px 0;
  }
  ul {
    margin-left: 36px;
    li {
      font-size: 24px;
      color: #333130;
      line-height: 36px;
    }
  }
}
.person-case {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 890px;
  margin: 0 auto;
  .case-img1 {
    width: 540px;
  }
  ul {
    width: 308px;
    li {
      font-size: 16px;
      color: #000;
      line-height: 18px;
      list-style: disc;
    }
  }
  .case-img2 {
    width: 404px;
  }
  .case-img3 {
    width: 423px;
  }
}
.person-consult {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 890px;
  margin: 0 auto;
  .consult-list {
    width: 350px;
    li {
      font-size: 18px;
      color: #333130;
      line-height: 38px;
      text-indent: 42px;
    }
  }
}
.consult-show {
  width: 548px;
  img {
    margin-bottom: 25px;
  }
  p {
    font-size: 18px;
    color: #333130;
    text-align: center;
    line-height: 24px;
    margin-bottom: 40px;
  }
}
.consult-space {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.personalized-list {
  display: flex;
  width: 928px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  .personal-cell {
    width: 302px;
    height: 240px;
    border: 1px solid #e9ebf4;
    padding: 0;
    margin-bottom: 30px;
    h5 {
      font-size: 20px;
      color: #33312f;
      height: 60px;
      line-height: 60px;
      background: #e9ebf3;
      padding-left: 11px;
      margin-bottom: 0;
    }
    p {
      font-size: 16px;
      color: #33312f;
      line-height: 16px;
      line-height: 32px;
      padding: 18px 11px;
    }
  }
}
</style>